export { TelegramBot, type TelegramBotConfig } from './bot';

// Re-export useful types from core
export type {
  ProcessorInput,
  ProcessorResult,
  CommandContext,
  CommandResult
} from 'weavebot-core';